import { Browser, getBrowserInfo, isMinimumBrowserVersion } from 'owa-user-agent';
import { isMiniFeatureEnabled } from 'owa-mini-feature-flags';

export const enum SkipRegistrationReasons {
    // Feature detection
    SwSupportUnavailable = 'SwSupportUnavailable',

    // Global switch
    DisabledForMiniApp = 'DisabledForMiniApp',

    // Safari
    DisabledForSafari = 'DisabledForSafari',
    ErrorSafariMinVersion = 'ErrorSafariMinVersion',

    // Chrome
    DisabledForChrome = 'DisabledForChrome',
    ErrorChromeMinVersion = 'ErrorChromeMinVersion',

    // UnsupportedBrowser
    UnsupportedBrowser = 'UnsupportedBrowser',
}

/**
 * Returns reason for skipping service worker registration, no reason means SW is supported
 */
export function getSkipRegistrationReason(): string {
    let reason: string;
    const { browser } = getBrowserInfo();
    if (!isMiniFeatureEnabled('mini-sw-enabled')) {
        reason = SkipRegistrationReasons.DisabledForMiniApp;
    } else if (browser === Browser.CHROME || browser === Browser.EDGE_CHROMIUM) {
        if (!isMiniFeatureEnabled('mini-sw-enabled-chrome')) {
            reason = SkipRegistrationReasons.DisabledForChrome;
        } else if (!isMinimumBrowserVersion([77])) {
            reason = SkipRegistrationReasons.ErrorChromeMinVersion;
        }
    } else if (browser === Browser.SAFARI) {
        if (!isMiniFeatureEnabled('mini-sw-enabled-safari')) {
            reason = SkipRegistrationReasons.DisabledForSafari;
        } else if (!isMinimumBrowserVersion([11, 4])) {
            reason = SkipRegistrationReasons.ErrorSafariMinVersion;
        }
    } else {
        reason = `${SkipRegistrationReasons.UnsupportedBrowser}_${reason}`;
    }
    return reason;
}
